import React from 'react';
import { motion } from 'framer-motion';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="border-y-4 border-aqua bg-petrol py-12 text-center text-white" aria-label="Oferta por tiempo limitado" data-id="element-330" data-mp="2sk43xcq97k7c">
      <div className="mx-auto max-w-3xl px-4" data-id="element-331" data-mp="36bsgfh4f0aou">
        <p className="text-xs font-extrabold uppercase tracking-[.16em] text-aqua" data-id="element-332" data-mp="31i6d4fk55j5p">Precio de lanzamiento · cierra en</p>
        <h2 className="mt-2 font-display text-2xl font-extrabold sm:text-3xl" data-id="element-333" data-mp="3g6kc2fefsngz">Tu ciclo lectivo puede estar listo hoy</h2>
        <Countdown light className="mt-6 scale-110 shadow-lg" data-id="element-334" data-mp="3bb4zrrw2uzmo" />
        <p className="mt-7 font-bold text-[#F0A9A3]" data-id="element-335" data-mp="3p7s78olnp86u">Después sube. No vuelve al precio de lanzamiento.</p>
        <div className="mx-auto mt-6 max-w-xl rounded-xl border border-aqua/40 bg-petrolDark p-4 text-sm" data-id="element-336" data-mp="3l8jgztptrsg1">
          <p className="font-bold" data-id="element-337" data-mp="1uvas64az1eda">
            <span className="mr-2 inline-block h-2.5 w-2.5 animate-pulse rounded-full bg-aqua" data-id="element-338" data-mp="1qt75ejiuqncp" />
            Cupos al precio de lanzamiento: quedan pocos
          </p>
          <div className="mt-3 h-3 overflow-hidden rounded-full bg-black/30" data-id="element-339" data-mp="2svhhrd6b5vok">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '71%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1
          }} className="h-full rounded-full bg-aqua" data-id="element-340" data-mp="2xtj0ty3qhv01" />
          </div>
          <p className="mt-1 text-right text-xs text-mutedDark" data-id="element-341" data-mp="3ci6tnwm73qma">71% tomados</p>
        </div>
      </div>
    </section>;
}